import { UserCheck, Cable, ShieldCheck, FileCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
    {
        icon: UserCheck,
        title: "Você fala com quem instala",
        text: "Sem call center e sem intermediários: o próprio técnico que faz o projeto responde pelo serviço.",
    },
    {
        icon: Cable,
        title: "Zero fios aparentes",
        text: "Cabeamento embutido e organizado, com acabamento que não destona com a arquitetura do prédio.",
    },
    {
        icon: ShieldCheck,
        title: "Equipamentos homologados",
        text: "Trabalhamos apenas com linhas de câmeras, leitores e motores com reputação comprovada no mercado.",
    },
    {
        icon: FileCheck,
        title: "Garantia registrada",
        text: "Cada instalação sai com termo de garantia e orientação de uso para o síndico ou morador.",
    },
];

const WhyUs = () => (
    <section className="relative py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="mb-14">
                <Eyebrow>[ 05 — Diferenciais ]</Eyebrow>
                <h2 className="mt-4 max-w-2xl font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] text-white">
                    Por que nos escolher
                    <span className="text-volt"> para proteger o seu espaço?</span>
                </h2>
            </Reveal>

            <div
                data-testid="why-us-differentials-grid"
                className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5"
            >
                {ITEMS.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.08} className="h-full">
                        <div className="h-full rounded-2xl border border-white/10 bg-panel p-7 hover:border-mint/40 transition-colors duration-300 group">
                            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-mint/30 bg-mint/10 text-mint transition-transform duration-300 group-hover:-translate-y-1">
                                <item.icon size={22} />
                            </span>
                            <h3 className="mt-6 font-display text-lg font-bold text-white">
                                {item.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                {item.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default WhyUs;
